import { render, staticRenderFns } from "./CompanyFeature.vue?vue&type=template&id=e64e9312"
import script from "./CompanyFeature.vue?vue&type=script&lang=js"
export * from "./CompanyFeature.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports